
import "./CreateClient.css";
import React, { useEffect, useState } from "react";
import { useGlobalContext } from "../../context";
import { business, radioType } from "../../interfaces";
import StarRateIcon from "@mui/icons-material/StarRate";

type propsData = {
    otherBusinessType: string,
    otherTerm: string,
    setOtherBusinessType: (newOtherBusinessType: string) => void,
    setOtherTerm: (newOtherTerm: string) => void,
    setLicense: (licens: string) => void,
    setHashtags: (hashtags: string) => void,
}

function BusinessTypeAndTerm(props: propsData) {

    const {
        businessType,
        setBusinessType,
        mortgageLogoType,
        setMortgageLogoType
    } = useGlobalContext();

    const {
        otherBusinessType,
        setOtherBusinessType,
        otherTerm,
        setOtherTerm,
        setLicense,
        setHashtags,
    } = props;

    const [activeBusiness, setActiveBusiness] = useState<business | undefined>();
    const [activeTerm, setActiveTerm] = useState<string>("");
    const [activeCategory, setActiveCategory] = useState<string>("");
    const [activeLogoType, setActiveLogoType] = useState<string>("");

    useEffect((): void => {
        const activeBusiness: business | undefined = businessType.find(item => item.active);
        if (activeBusiness) {
            setActiveBusiness(activeBusiness);
            const findActiveTerm: radioType | undefined = activeBusiness.terms.find((item:radioType) => item.active);
            const findActiveCategory: radioType[] | undefined = activeBusiness.categories?.filter((item: radioType) => item.active);

            if (findActiveCategory) {
                setActiveCategory(findActiveCategory.map(item => item.title).join(", "));
            }
            if (findActiveTerm) {
                setActiveTerm(findActiveTerm.title);
            }
            if (activeBusiness.title === "Real Estate") {
                setLicense("Lic. #");
                setHashtags("#realestate #realtor #realestateagent #property #listing #buy #sell #house #realestateexpert #professionalservice #toprealestateagent #househunting #homeforsale #dreamhome")
            }
            else if (activeBusiness.title === "Mortgage") {
                setLicense("NMLS #");
                setHashtags("#loan #mortgage #property #refinance #mortgagepreapproval #mortgageagent #constructionloan #mortgageprofessional #dreamhome");
            }
            else if (activeBusiness.title === "Investment") {
                setLicense("");
                setHashtags("#HomesforCash #cashoffer #fastclosings #fastcash #cashofferforyourhome #HousingMarket #QuickSale #FairDeal")
            }
            else if (activeBusiness.title === "Insurance") {
                setLicense("Lic. #");
                setHashtags("#insurance #insuranceagent #insurancebroker #insuranceagency #insurancepolicy #insurancequote #protection #money #financialplanning #financialfreedom")
            }
            else {
                setLicense("");
                setHashtags("");
            }
        }
    }, [businessType]);

    useEffect(() => {
        const activeLogo = mortgageLogoType.find(item => item.active);
        if (activeLogo) setActiveLogoType(activeLogo.title);
        else setActiveLogoType("");
    }, [mortgageLogoType]);

    const handleChange = (item: business): void => {
        setBusinessType((businessType: business[]) => businessType.map((type: business) => type.id === item.id ? { ...type, active: true } : { ...type, active: false }));
        setOtherBusinessType("");
        setOtherTerm("");
    }

    const handleTerm = (concretTerm: radioType): void => {
        setBusinessType((businessType: business[]) => businessType.map((type: business) => {
            if (type.title === activeBusiness?.title) {
                return {
                    ...type,
                    terms: type.terms.map((term:radioType) => term.id === concretTerm.id ? { ...term, active: true } : { ...term, active: false }),
                };
            }
            else {
                return { ...type };
            }
        }));
        setOtherTerm("");
    }

    const handleCategory = (category: radioType) => {
        setBusinessType((businessType: business[]) => businessType.map((type: business) => {
            if (type.title === activeBusiness?.title) {
                return {
                    ...type,
                    categories: type.categories?.map((ctg: radioType) => ctg.id === category.id ? { ...ctg, active: !ctg.active } : { ...ctg }),
                };
            }
            else {
                return { ...type };
            }
        }));
    }

    const handleLogoType = (logoType: radioType): void => {
        setMortgageLogoType(mortgageLogoType => mortgageLogoType.map(item => item.id === logoType.id ? {...item, active: true} : {...item, active: false}))
    }

    return (
        <div className="BusinessTypeAndTerm" style = {{ margin: "30px 0 0 0" }}>
            <div className="createClient-form-package">
                <label className="required"> Business Type <StarRateIcon style = {{ color: "red", fontSize: "10px" }}/></label>
            </div>
            {
                businessType.map((item: business, index: number) => {
                    if (item.title !== "Other") {
                        return <div className = "form-package-box"
                                    key = { index }
                                    onClick = {() => handleChange(item)}
                                >
                                    <input
                                        className = "packageOption"
                                        type = "radio"
                                        checked = { item.title === activeBusiness?.title }
                                        name = {"business"}
                                    />
                                    <label>{ item.title }</label>
                                </div>
                    }
                    else {
                        return (
                            <div
                                className = "form-package-box"
                                key = { index }
                                onClick = {() => handleChange(item)}
                            >
                                <input
                                    className = "packageOption"
                                    type = "radio"
                                    checked = { item.title === activeBusiness?.title }
                                    name = { "business" }
                                />
                                {
                                    activeBusiness?.title === "Other"
                                        ?
                                        <input
                                            type = "text"
                                            placeholder = "Other"
                                            value = { otherBusinessType }
                                            onChange = { e => setOtherBusinessType(e.target.value) }
                                            autoFocus
                                            className = "custom-package-input"
                                        />
                                        :
                                        <label htmlFor="socialOther">{ item.title }</label>
                                }
                            </div>
                        )
                    }
                })
            }
            {
                activeBusiness?.title !== 'Other' && activeBusiness?.categories  ?
                    <div className="createClient-form-package" style = {{ margin: "30px 0 0 0" }}>
                        <label className="required">
                            Business Category<StarRateIcon
                            style = {{ color: "red", fontSize: "10px" }}/>
                        </label>
                        {
                            businessType.find((item: business) => item.title === activeBusiness?.title)?.categories?.map((ctg: radioType) => {
                                return (
                                    <div
                                        className = "form-package-box"
                                        key = { ctg.id }
                                        onClick = {() => handleCategory(ctg)}
                                    >
                                        <input
                                            className = "packageOption"
                                            type = 'checkbox'
                                            checked = { activeCategory.includes(ctg.title) }
                                            style = {{ display: 'inline-block' }}
                                        />
                                        {
                                            <label style = {{ margin: 0 }}>{ ctg.title }</label>
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                    :
                    null
            }
            {
                activeBusiness?.title !== "Other" ?
                    <>
                        <div className="createClient-form-package" style = {{ margin: "30px 0 0 0" }}>
                            <label className="required">
                                Term to be used for {activeBusiness?.title}<StarRateIcon
                                style = {{ color: "red", fontSize: "10px" }}/>
                            </label>
                        </div>
                        {
                            businessType
                                .find((item: business) => item.title === activeBusiness?.title)?.terms
                                .map((term: radioType) => {
                                    return <div className = "form-package-box" key = { term.id }
                                                onClick = {() => handleTerm(term)}
                                    >
                                        <input
                                            className = "packageOption"
                                            type = "radio"
                                            checked = { term.title === activeTerm }
                                            name = { "term" }
                                        />
                                        {
                                            term.title === 'Other' && activeTerm === 'Other' ?
                                                <input
                                                    type = "text"
                                                    placeholder = "Other term"
                                                    value = { otherTerm }
                                                    onChange = { e => setOtherTerm(e.target.value) }
                                                    autoFocus
                                                    className = "custom-package-input"
                                                />
                                                :
                                                <label htmlFor="socialOther">{ term.title }</label>
                                        }
                                    </div>
                                })
                        }
                    </>
                    :
                    <>
                        <div className="createClient-form-package" style={{margin: "30px 0 0 0"}}>
                            <label className="required">
                                Term to be used for { activeBusiness.title } Business Type<StarRateIcon
                                style = {{ color: "red", fontSize: "10px" }}/>
                            </label>
                        </div>
                        <input
                            type = "text"
                            placeholder = "Other term"
                            value = { otherTerm }
                            onChange = {e => setOtherTerm(e.target.value)}
                            className = "custom-package-input"
                            style = {{
                                margin: "20px 0 0 30px"
                            }}
                        />
                    </>
            }
            {
                activeBusiness?.title === "Mortgage" ?
                    <>
                        <div className="createClient-form-package" style = {{margin: "30px 0 0 0"}}>
                            <label className="required">Choose which Equal Housing Logo do you want to use in your branding materials:<StarRateIcon
                                style = {{ color: "red", fontSize: "10px" }}/>
                            </label>
                        </div>
                        {
                            mortgageLogoType.map((item: radioType) =>
                                <div
                                    className = "form-package-box"
                                    key = { item.id }
                                    onClick = {() => handleLogoType(item)}
                                >
                                    <input
                                        className = "packageOption"
                                        type = "radio"
                                        checked = { item.title === activeLogoType }
                                        name = { "logoType" }
                                    />
                                    <label>{ item.title }</label>
                                </div>
                            )
                        }
                    </>
                : null
            }
        </div>
    )
}

export default BusinessTypeAndTerm;
